export default "__VITE_ASSET__960873dc__"